<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Conectada"
        class="logo"
      />

      <div class="texts">
        <h2>Senha redefinida com sucesso.</h2>
      </div>

      <form class="form-fields">
        <button
          mat-raised-button
          color="primary"
          class="submit-button"
          type="submit"
        >
          Acessar
        </button>
      </form>

      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
